import { render, staticRenderFns } from "./PasteRecord.vue?vue&type=template&id=db2848da&scoped=true&"
import script from "./PasteRecord.vue?vue&type=script&lang=js&"
export * from "./PasteRecord.vue?vue&type=script&lang=js&"
import style0 from "./PasteRecord.vue?vue&type=style&index=0&id=db2848da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2848da",
  null
  
)

export default component.exports